/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { Fragment, useState, createRef, useEffect, useContext } from 'react';
import { useSelector, connect } from 'react-redux';

import API from 'constants/api';
import { validateObject } from 'validation/objectValidation';
import { copyObject, autosaveObject } from 'actions/objectActions';
import { editObjectWithGeometry, checkStatementPdfFieldsEdited} from 'actions/spectrumActions';
import { setAlert } from 'actions/viewActions';
import { getUniquenessMessage } from 'actions/validationActions';

import Loading from 'components/common/Loading';
import SaveButton from 'components/common/SaveButton';
import LocaleContext from 'constants/localization';
import ArchivedObjectAccordions from 'components/archived-object/ArchivedObjectAccordions';

import FieldEdit from 'field/edit/FieldEdit';

const EditObject = ({ tabs, view, uri, validateObject, checkStatementPdfFieldsEdited,
  editObjectWithGeometry, copyObject, autosaveObject, setAlert }) => {
  const formRef = createRef();
  const validated = useSelector(state => state.object.validated);
  const loading = useSelector(state => state.object.loading);
  const LS = useContext(LocaleContext);
  const saveDisabled = tabs.length === 0;
  const [statementHasPdf, setStatementHasPdf] = useState(false); 
  // #211 - disable copy button for statements because they are a bit special
  const displayCopyButton = view != "Statement";

  useEffect(() => {
	// Check if the statement has a signable PDF document. This field is not available in the edit view
	if(view === "Statement" && uri){
		let url = `${API.CE}/statementHasPdf?uri=${uri}`;
		fetch(url,
  	      	{
  	        	method: 'GET'
  	      	})
			.then(res => res.json())
			.then(json => {
				if (json.statementHasPdf) {
					setStatementHasPdf(true);
				}
			}).catch(e => {
				console.log(e);
			});
	}
    const autosaveInterval = autosaveObject();
    return () => clearInterval(autosaveInterval);
  }, []);

  const validateOnSave = () => {
    const { isValid, invalidFields } = validateObject(formRef);

	if(view === "Statement" && statementHasPdf){
		const isStatementFieldsEdited = checkStatementPdfFieldsEdited(formRef);
		if(isStatementFieldsEdited){
			if (confirm(LS.prompt.editStatement)) {
				let url = `${API.CE}/deleteStatementPdf?uri=${uri}`;
				fetch(url,
		  	      	{
		  	        	method: 'POST'
		  	      	})
					.then(res => res.json())
					.then(json => {
						if (json.success) {
							createNotification("Lausunnon PDF dokumentti poistettu.");
							return editObject(isValid);
						}
					}).catch(e => {
						console.log(e);
					});
		    }else{
				return false;
			}
		}else{
			 return editObject(isValid);
		}
	}else{
	    return editObject(isValid);
    }
  };
  
  const editObject = (isValid) => {
	if (isValid) {
      const uniqMessage = getUniquenessMessage({view: view }, LS);
      return editObjectWithGeometry('', uniqMessage);
    } else {
      setAlert({
        header: LS.error.invalidFields, 
        contents: invalidFields.join('\n'), 
        variant: 'danger'});
    }
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Fragment>
      <ArchivedObjectAccordions
        tabs={tabs}
        Field={FieldEdit}
        formRef={formRef} 
        validated={validated}
      />
      <SaveButton accessKey="s" onSubmit={validateOnSave} disabled={saveDisabled} />
      {displayCopyButton && <SaveButton onSubmit={copyObject} disabled={saveDisabled} label={LS.actions.copyObject} /> }
    </Fragment>
  ); 
};

export default connect(null, { validateObject, editObjectWithGeometry, checkStatementPdfFieldsEdited, 
  copyObject, autosaveObject, setAlert })(EditObject);